import { render, staticRenderFns } from "./SuppliersSection.vue?vue&type=template&id=7c3f0308"
import script from "./SuppliersSection.vue?vue&type=script&lang=js"
export * from "./SuppliersSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports